import { useState, useEffect } from "react";
import Header from "../layout/header";
import MaterialTable from "material-table";
import { ArrowDownward } from "@material-ui/icons";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Add from "@material-ui/icons/Add";
import Check from "@material-ui/icons/Check";
import FilterList from "@material-ui/icons/FilterList";
import Remove from "@material-ui/icons/Remove";
import Clear from "@material-ui/icons/Clear";
import Edit from "@material-ui/icons/Edit";
import { Loader } from "react-overlay-loader";
import { axiosInstance } from "../config/https";
import { toast } from "react-toastify";
// import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { saveAs } from 'file-saver';
// import { makeStyles } from '@material-ui/core/styles';
// import MaterialTable from 'material-table';
// import { SaveAlt } from '@material-ui/icons';


export default function Upload() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [excelFile, setExcelFile] = useState([]);
  const navigate = useNavigate();
  
  const [, setMessage] = useState([]);


  const handleContactus = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', excelFile)

    try {
      const response = await axiosInstance.post('/import/users', formData);

      console.log(response, 'Success');
      if (response.data.status === true) {
        toast.success('Details submit successful');
        setMessage(response?.data?.message);
        setErrors({});
        setShowModal(false);
      } else {
        const apiErrors = response?.data?.data;
        if (apiErrors) {
          setErrors(apiErrors);
        } else {
        toast.error('Form Submission Failed');
      }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

// File change handler for Excel file upload
const handleFileUpload = (e) => {
    const selectedFile = e.target.files[0];
    setExcelFile(selectedFile);
  };

  // useEffect(() => {
  //   GetExport();
  // }, []);

  const handleClose = () => setShowModal(false); 

  // GET users
  // const GetExport = () => {
  //   setLoader(true);
  //   axiosInstance.get("/export/users").then((response) => {
  //     setLoader(false);
  //     console.log("res", response);

  //     if (response?.data?.status) {
  //       setData(response.data.data);
  //     } else {
  //       toast.warning(response?.data?.message);
  //     }
  //   });
  // };

  const handleExport = () => {
    setLoader(true);
    axiosInstance.get("/export/users", {
      responseType: 'blob',
    })
      .then((response) => {
        setLoader(false);
        console.log("res", response);

        saveAs(response.data, 'exported_data.xlsx');
      })
      .catch((error) => {
        setLoader(false);
        console.error('Error exporting data: ', error);
      });
  };

//   const [, setDltData] = useState();
//   const handleDelete = (rowData) => {
    
//     setLoader(true);
//     axiosInstance.post(`/del/user/${rowData.id}`).then((response) => {
//       setLoader(false);
//       console.log("res", response);

//       if (response?.data?.status) {
//         setDltData(response.data.data);
//         GetExport();
//       } else {
//         toast.warning(response?.data?.message);
//       }
//     });
//   };

  return (
    <>
    <div>
      {loader === true ? <Loader fullPage loading /> : null}

      <Header />
      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row">
            <div className="content-header-left col-md-6 col-12 mb-2 breadcrumb-new">
              <h3 className="content-header-title mb-0 d-inline-block">
                Users Data
              </h3>
            </div>
            <div class="content-header-right col-md-6 col-12">
            <div class="dropdown float-md-right">
                <button
                style={{backgroundColor: "#1E9FF2"}}
                class="btn btn round btn-glow px-2"
                type="button"
                onClick={() => setShowModal(true)}
              >
                Import User
              </button>
            </div>
            </div>
          </div>

          <div className="content-body d-flex justify-content-center">
          <Card className="col-md-12">
            <CardBody>
            <div id="wrap">
              <Link to="#" className="btn-slide2" onClick={handleExport}>
                <span className="circle2"><i className="fa fa-download"></i></span>
                <span className="title2">Export Users</span>
                <span className="title-hover2">Click here</span>
              </Link>
            </div>
            </CardBody>
          </Card>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Import User</Modal.Title>
          <IoMdClose size={24} className="close-icon" onClick={handleClose} /> {/* Close icon */}
        </Modal.Header>
        <Modal.Body>
        <form id="userForm"  onSubmit={handleContactus}>
        <div className="form-group">
        <label htmlFor="fileUpload">Upload File</label>
        <input
            type="file"
            className="form-control-file"
            id="fileUpload"
            onChange={handleFileUpload}
            accept=".csv,.xlsx"
            required
        />
        {errors && <span className="error">{errors.file}</span>}
        </div>
        <div className="pt-2 d-flex justify-content-end">
          <button type="submit" class="btn btn" style={{backgroundColor: "#1E9FF2"}}>Submit</button>
          </div>
        </form>
        </Modal.Body>
      </Modal>
    </div>
    <style>
      {
        `
        #wrap {
          margin: 20px auto;
          text-align: center;
      }
      
      .btn-slide, .btn-slide2 {
          position: relative;
          display: inline-block;
          height: 50px;
          width: 200px;
          line-height: 50px;
          padding: 0;
          border-radius: 50px;
          background: #0099cc;
          border: 2px solid #0099cc;
          margin: 10px;
          transition: .5s;
      }
      
      .btn-slide2 {
          border: 2px solid #0099cc;
      }
      
      .btn-slide:hover {
          background-color: #0099cc;
      }
      
      .btn-slide2:hover {
          background-color: #0099cc;
      }
      
      .btn-slide:hover span.circle, .btn-slide2:hover span.circle2 {
          left: 100%;
          margin-left: -45px;
          background-color: white;
          color: white;
      }
      
      .btn-slide2:hover span.circle2 {
          color: white;
      }
      
      .btn-slide:hover span.title, .btn-slide2:hover span.title2 {
          left: 40px;
          opacity: 0;
      }
      
      .btn-slide:hover span.title-hover, .btn-slide2:hover span.title-hover2 {
          opacity: 1;
          left: 40px;
      }
      
      .btn-slide span.circle, .btn-slide2 span.circle2 {
          display: block;
          background-color: white;
          color: white;
          position: absolute;
          float: left;
          margin: 5px;
          line-height: 42px;
          height: 40px;
          width: 40px;
          top: 0;
          left: 0;
          transition: .5s;
          border-radius: 50%;
      }
      
      .btn-slide2 span.circle2 {
          background-color: white;
      }
      
      .btn-slide span.title,
        .btn-slide span.title-hover, .btn-slide2 span.title2,
        .btn-slide2 span.title-hover2 {
          position: absolute;
          left: 90px;
          text-align: center;
          margin: 0 auto;
          font-size: 16px;
          font-weight: bold;
          color: white;
          transition: .5s;
      }
      
      .btn-slide2 span.title2,
        .btn-slide2 span.title-hover2 {
          color: white;
          left: 80px;
        }
      
      .btn-slide span.title-hover, .btn-slide2 span.title-hover2 {
          left: 80px;
          opacity: 0;
      }
      
      .btn-slide span.title-hover, .btn-slide2 span.title-hover2 {
          color: white;
      }
        `
      }
    </style>
  </>
  );
}
